import React, { FunctionComponent } from "react";

const ErrorPage: FunctionComponent = () => {
    return <div className="ErrorPage">
        404! Page not found!
    </div>
}

export default ErrorPage;